<input
  [type]="col.inputType || 'text'"
  [formControl]="control"
  [placeholder]="col.placeholder || ''"
  class="kt-input kt-input-sm"
/>

<mat-error
  *ngIf="control?.invalid &&
         control?.touched">

  {{ getError() }}

</mat-error>